/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateOrderbookOptions, UpdateOrderbookResponses } from '../types/UpdateOrderbook'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update an existing orderbook
 * {@link /v1/orderbooks/:order_book_id}
 */
export function updateOrderbook<ThrowOnError extends boolean = true>(
  options: Options<UpdateOrderbookOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateOrderbookResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/orderbooks/{order_book_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateOrderbookResponses, ThrowOnError>>,
  )
}
